import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { Icon } from 'src/design_system/atoms/icons/components/Icon'
import { useSelector } from 'src/hooks'

type AffiliateFormButtonProps = {
  onDownload: () => void
  title: string
  hasDownloaded: boolean
}

export const AffiliateFormButton = (props: AffiliateFormButtonProps) => {
  const { onDownload, title, hasDownloaded } = props
  const isMobile = useSelector(state => state.window.isMobile)
  const isSmallMobile = useSelector(state => state.window.width <= 400)

  return (
    <Flex
      style={{
        alignSelf: 'stretch',
        backgroundColor: 'white',
        borderRadius: '14px',
        justifyContent: 'space-between',
        boxShadow:
          '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        alignItems: 'center',
        padding: `14px ${isSmallMobile ? 8 : 12}px`,
      }}
    >
      <Flex
        onClick={onDownload}
        cursor="pointer"
        justifyContent="center"
        alignItems="center"
        flexDirection="row"
        columnGap={isMobile ? 'x_5' : 'x1'}
      >
        {!isSmallMobile && (
          <Div
            style={{
              backgroundColor: '#F9FAFB',
              borderRadius: '8px',
              display: 'flex',
              padding: '8px',
              alignItems: 'center',
            }}
          >
            <Icon name="form" />
          </Div>
        )}
        <Text
          color="primaryBody"
          type={isMobile ? 'footnote' : 'caption'}
          weight="semiBold"
          content={title}
          whiteSpace="nowrap"
        />
        {!isMobile && <Icon name="download" />}
      </Flex>
      <Div
        display="flex"
        onClick={onDownload}
        justifyContent="center"
        flexDirection="row"
        columnGap="x_5"
        cursor="pointer"
        alignItems="center"
        style={{
          backgroundColor: hasDownloaded ? '#ECFDF5' : '#F9FAFB',
          padding: isMobile ? '8px 10px' : '12px 20px',
          borderRadius: '44px',
        }}
      >
        <Icon size={18} name={isMobile ? 'download_2' : 'edit_document'} />
        <Text
          color="primaryHeading"
          type="footnote"
          weight="bold"
          content="Download"
          whiteSpace="nowrap"
          style={{ display: isMobile ? 'none' : 'initial' }}
        />
      </Div>
    </Flex>
  )
}
